import { createAsyncThunk } from "@reduxjs/toolkit";
import { getValuesSocketData } from "helpers/secretManager";
import * as URL from "helpers/url_helper";
import { get, post, put, del } from "helpers/api_helper";
import { toast } from "react-toastify";

export const getLanguageList = createAsyncThunk(
  "getLanguageList",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(URL.GET_LANGUAGE_LIST, data, {
        signature,
        nonce,
      });
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      callback && callback(null, response.data);
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error?.message || "Something went wrong!");
      return Thunk.rejectWithValue(error);
    }
  },
);

export const addLanguage = createAsyncThunk(
  "AddLanguage",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(URL.ADD_LANGUAGE, data, { signature, nonce });
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      callback && callback(null, response);
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error.message, null);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const editLanguage = createAsyncThunk(
  "editLanguage",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await put(URL.EDIT_LANGUAGE + data?._id, data, {
        signature,
        nonce,
      });
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      callback && callback(null, response);
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error.message, null);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const deleteLanguage = createAsyncThunk(
  "deleteLanguage",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await del(URL.DELETE_LANGUAGE + data?._id, data, {
        signature,
        nonce,
      });
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      callback && callback(null, response);
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error.message, null);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const getLanguagesCode = createAsyncThunk(
  "getLanguagesCode",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await get(URL.GET_LANGUAGE_CODES, { signature, nonce });
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      callback && callback(null, response);
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error.message, null);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const getLanguageJSON = createAsyncThunk(
  "getLanguageJSON",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await get(URL.GET_LANGUAGE_JSON + data.languageCode, {
        signature,
        nonce,
      });
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      callBack && callBack(null, response.data);
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callBack && callBack(error.message, null);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const updateLanguageKey = createAsyncThunk(
  "updateLanguageKey",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(URL.GET_LANGUAGE_JSON, data, {
        signature,
        nonce,
      });
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      callback && callback(null, response.data);
      return response;
    } catch (error) {
      return Thunk.rejectWithValue(error);
    }
  },
);
